import { defaultApiBasicX, defaultApiBasicXLegacyToken } from '@wiggot/apis'
import { IDataInvitation } from '../store/modals-services/modal-broker-invitation'
import type { IResponseService } from '../../interfaces'

export const ERROR_MESSAGES_INVITATION_AGENCY = {
  'User already has an agency': 'Ya eres parte de una agencia',
  'Agency not found': 'La agencia a la que te invitaron no se encuentra',
  'Invite not found': 'La invitación ya no existe'
}

export const getAgencyInvites = async ({
  email,
  agencyId,
  requestType,
  status
}: {
  agencyId?: string
  email?: string
  requestType?: 'INVITATION' | 'REQUEST'
  status?: ('PENDING' | 'ACCEPTED' | 'REJECTED' | 'EXPIRED' | 'DECLINED')[]
}): Promise<IResponseService<IDataInvitation[]>> => {
  try {
    const res = await defaultApiBasicX.get<{
      data: IDataInvitation[]
    }>(`/users-management/agency/collaborator/invite`, {
      params: {
        agencyId,
        email,
        requestType,
        status: status?.join(',')
      }
    })

    return {
      isSuccess: true,
      data: res?.data
    }
  } catch (error) {
    return {
      isSuccess: false,
      error
    }
  }
}

interface IPostHandleInvitationCollaborators {
  inviteId: string
  usage?: 'accept' | 'reject' | 'declined'
  statusAccepted?: boolean
  role?: 'ROLE_AGENCY_BROKER' | 'ROLE_AGENCY'
}

export const postHandleInvitationCollaborators = async ({
  inviteId,
  usage,
  statusAccepted,
  role
}: IPostHandleInvitationCollaborators) => {
  const response = await defaultApiBasicXLegacyToken.post<
    {
      data: {
        roles: number
        agencyId: number
        agencyName: string
      }
      message: string
      statusCode: number
    },
    IPostHandleInvitationCollaborators
  >(`/users-management/agency/collaborator/invite/usage`, {
    inviteId,
    usage,
    statusAccepted,
    role
  })

  try {
    return {
      isSuccess: true,
      data: response.data,
      errorMessage:
        ERROR_MESSAGES_INVITATION_AGENCY?.[
          response?.message as keyof typeof ERROR_MESSAGES_INVITATION_AGENCY
        ]
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error,
      errorMessage:
        ERROR_MESSAGES_INVITATION_AGENCY?.[
          error?.error?.response?.data
            ?.message as keyof typeof ERROR_MESSAGES_INVITATION_AGENCY
        ]
    }
  }
}

export interface IResSuccess {
  emailsWithAgency: string[]
  emailsInviteSended: string[]
  emailsInviteReSended: any[]
}

export const postInvitationCollaborators = async ({
  agencyId,
  emails,
  emailsWithTypeInvitation
}: {
  agencyId: string
  emails?: string[]
  emailsWithTypeInvitation?: {
    email: string
    roleName: 'ROLE_AGENCY_BROKER' | 'ROLE_AGENCY'
  }[]
}): Promise<IResponseService<IResSuccess>> => {
  const response = await defaultApiBasicX.post<any, any>(
    `/users-management/agency/collaborator/invite`,
    {
      emails: emailsWithTypeInvitation ?? emails,
      agencyId
    }
  )

  try {
    return {
      isSuccess: true,
      data: response?.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
